import React, { useState } from 'react';

import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IContract } from 'src/types/contract';
import { CellProps } from 'react-table';

import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import GeneralEnum from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';

import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import styles from '../assets/contract-grid.module.scss';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import ContractActionsColumn from './ContractActionsColumn';
import { IProvider } from '../../../../../../../../../types/provider';

interface Props {
    data: Paginated<Partial<IContract>>;
    getData: (params: QueryParams) => void;
    student: string;
}

const ContractGrid: React.FunctionComponent<Props> = ({ data, getData, student }: Props) => {
    const statusEnum = GeneralEnum ? GeneralEnum.getEnum('ContractStatusDocusign') : {};
    const languageEnum = GeneralEnum ? GeneralEnum.getEnum('ContractLanguage') : {};

    const statuses: SelectObject[] = getValFromEnum(statusEnum);
    const languages: SelectObject[] = getValFromEnum(languageEnum);

    const [columns, setColumns] = useState<any>([]);

    const getColumns = (student: any): Column<IContract>[] => [
        {
            Header: '#',
            accessor: 'id',
            width: 40,
            disableSortBy: true,
            disableFilters: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                return original.id;
            },
            Filter: textFilter<IContract>(),
        },
        {
            Header: 'Date',
            accessor: 'createdAt',
            width: 140,
            disableFilters: true,
            disableSortBy: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                const value = original.createdAt;
                return value ? `${changeToZeroMoment(value, 'MMM D, YYYY')}` : '';
            },
            Filter: dateTimeFilter<IContract>(),
        },
        {
            Header: 'Case Number',
            // disableSortBy: true,
            // disableFilters: true,
            width: 140,
            accessor: 'caseNumber',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                return original.caseNumber;
            },
            Filter: textFilter<IContract>(),
        },
        {
            Header: 'Language',
            accessor: 'language',
            width: 80,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                const valueLang = languages.find((it) => +it.value === original.language);
                return valueLang ? valueLang.label : '';
            },
            Filter: dropdownFilter<IContract>(languages, styles.minWidth),
        },
        {
            Header: 'Orders',
            accessor: 'contractOrders',
            disableSortBy: true,
            width: '45%',
            minWidth: 320,
            Filter: textFilter<IProvider>(),
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<any>) => {
                if (!original.contractOrders || !original.contractOrders.length) return null;

                return (
                    <div className={styles.ordersCell}>
                        {original.contractOrders.map((s: any, index: number) => {
                            const name = s?.orderEntity?.name;
                            const id = s?.orderEntity?.id;
                            if (!id || !name) return null;

                            const url = Router.generate(routes.ORDER_DETAIL, { id });
                            return (
                                <a key={index} href={url} target="_blank" rel="noopener noreferrer">
                                    {name}
                                </a>
                            );
                        })}
                    </div>
                );
            },
        },

        {
            Header: 'Status',
            accessor: 'statusDocusign',
            width: '8%',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                const valueStatus = statuses.find((it) => +it.value === original.statusDocusign);
                return valueStatus ? valueStatus.label : '';
            },
            Filter: dropdownFilter<IContract>(statuses, styles.minWidth),
        },
        {
            Header: 'Document',
            accessor: 'contractAttachSigned',
            disableSortBy: true,
            disableFilters: true,
            width: '12%',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IContract>) => {
                if (original.contractAttachSigned) {
                    return (
                        <a rel="noopener noreferrer" target="_blank" href={original.contractAttachSigned}>
                            Contract Document.pdf
                        </a>
                    );
                } else if (original.contractAttach) {
                    return (
                        <a rel="noopener noreferrer" target="_blank" href={original.contractAttach}>
                            Contract Document.pdf
                        </a>
                    );
                }
            },
            Filter: textFilter<IContract>(),
        },
        {
            Header: 'Actions',
            accessor: 'updatedAt',
            Cell: ContractActionsColumn,
            disableSortBy: true,
            disableFilters: true,
            width: '8%',
        },
    ];
    if (!columns.length) {
        setColumns(getColumns(student));
    }
    return (
        <div>
            <Grid<Partial<IContract>> columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default ContractGrid;
